import { Outlet } from 'react-router-dom'
import jooustLogo from 'images/jooust-logo.jpeg'
import impactHeLogo from 'images/impacthe-logo.png'
import euLogo from 'images/eu-logo.png'

const supportedBy = [
  { src: impactHeLogo, alt: 'Impact HE Project' },
  { src: euLogo, alt: 'European Union' },
]

export default function AuthLayout() {
  return (
    <div className="flex min-h-svh w-full">
      <div className="relative hidden min-h-svh w-[42%] flex-col items-center justify-center overflow-hidden bg-[#0b3d2b] px-12 text-white lg:flex">
        <div
          className="absolute inset-0 opacity-30"
          style={{
            backgroundImage:
              'radial-gradient(circle at 20% 20%, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.08) 0, rgba(255,255,255,0.08) 1px, transparent 1px)',
            backgroundSize: '120px 120px',
          }}
        />
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage:
              'repeating-linear-gradient(0deg, rgba(255,255,255,0.08), rgba(255,255,255,0.08) 1px, transparent 1px, transparent 60px), repeating-linear-gradient(90deg, rgba(255,255,255,0.08), rgba(255,255,255,0.08) 1px, transparent 1px, transparent 60px)',
          }}
        />

        <div className="relative z-10 flex w-full max-w-lg flex-col items-center gap-6 text-center">
          <div className="flex flex-col items-center gap-4">
            <div className="flex size-32 items-center justify-center rounded-full bg-white/10 p-3">
              <img
                src={jooustLogo}
                alt="JOOUST Logo"
                className="size-20 rounded-full bg-white p-2 object-contain"
              />
            </div>
            <div className="h-1 w-16 rounded-full bg-[#d6a64a]" />
          </div>

          <div className="space-y-1">
            <p className="text-base font-semibold leading-tight">
              Jaramogi Oginga Odinga University of
            </p>
            <p className="text-base font-semibold leading-tight">
              Science and Technology
            </p>
            <p className="text-[11px] tracking-[0.35em] text-white/60">JOOUST</p>
          </div>

          <div className="mt-2 w-full rounded-full border border-white/20 bg-white/5 px-6 py-2 text-[11px] font-semibold tracking-[0.3em] text-white/80">
            PROJECT MANAGEMENT &amp; IMPACT ASSESSMENT SYSTEM
          </div>
          <p className="text-[11px] text-white/50">UPMIAS v2.0</p>
        </div>

        <div className="relative z-10 mt-14 flex w-full flex-col items-center gap-4">
          <p className="text-[11px] tracking-[0.35em] text-white/50">SUPPORTED BY</p>
          <div className="flex items-center gap-4 rounded-lg px-5 py-3">
            {supportedBy.map((logo) => (
              <img
                key={logo.alt}
                src={logo.src}
                alt={logo.alt}
                className="h-8 w-auto object-contain"
              />
            ))}
          </div>
          <p className="text-[11px] text-white/40">
            Copyright © 2026 JOOUST — All Rights Reserved
          </p>
        </div>
      </div>

      <div className="flex min-h-svh w-full items-center justify-center bg-[#f6f7f4] px-6 py-10 lg:w-[58%]">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
